import { cn } from '@/lib/utils'
import { JobillaLogo } from '@/ui/rapid-ui'
import type { ReactNode } from 'react'

type Props = {
	children: ReactNode
	aside?: ReactNode
}

// The logo's gradients are referenced by id, so it must render only once.
export function OnboardingLayout({ children, aside }: Props) {
	return (
		<div className="min-h-screen bg-gradient-to-br from-brand-50 via-background to-background px-4 py-8 sm:px-6 lg:py-16">
			<div
				className={cn(
					'mx-auto grid w-full max-w-xl',
					aside
						&& 'lg:max-w-none lg:grid-cols-[13rem_minmax(0,36rem)] lg:grid-rows-[auto_1fr] lg:justify-center lg:gap-x-14',
				)}
			>
				<div
					className={cn(
						'mb-6 justify-self-center text-brand-800 [&>svg]:h-8 [&>svg]:w-auto',
						aside && 'lg:mb-12 lg:justify-self-start',
					)}
				>
					<JobillaLogo />
				</div>
				{aside && (
					<aside className="sticky top-16 hidden self-start lg:col-start-1 lg:row-start-2 lg:block">
						{aside}
					</aside>
				)}
				<div
					className={cn(
						'w-full overflow-hidden rounded-2xl border border-brand-100 bg-card p-6 shadow-sm sm:p-8 md:p-12',
						aside && 'lg:col-start-2 lg:row-span-2 lg:row-start-1',
					)}
				>
					{children}
				</div>
			</div>
		</div>
	)
}
